export const PRODUCTCAROUSEL_DATA_LOAD = 'productCarousel/PRODUCTCAROUSEL_DATA_LOAD';
export const PRODUCTCAROUSEL_DATA_SUCCESS = 'productCarousel/PRODUCTCAROUSEL_DATA_SUCCESS';
export const PRODUCTCAROUSEL_DATA_FAIL = 'productCarousel/PRODUCTCAROUSEL_DATA_FAIL';
